import React from 'react';

// Form watches for updates and maintains state by sending state through
// `onValidUpdate`.
export default class Form extends React.Component {

  componentDidMount() {
    this.inputs = [...this.form.getElementsByTagName('input')]

    for (let input of this.inputs) {
      input.addEventListener('input', this.validate)
    }

    this.validate()
  }

  validate = () => {
    const valid = this.inputs.reduce((val, i) => val && i.validity.valid)

    this.props.onValidUpdate && this.props.onValidUpdate(valid)
  }

  render() {
    const { onValidUpdate, ...props } = this.props

    return (
      <form ref={ref => this.form = ref} {...props}>
        { this.props.children }
      </form>
    )
  }
}



// WEBPACK FOOTER //
// ./client/Components/Form/Form/Form.jsx